<template>
  <div class="pb-5">
    <h2 class="title mx-4 mt-4 mb-1 text-xs-left" style="font-weight:400;">Configuração financeira</h2>
    <div
      class="caption text-xs-left pb-3 px-4"
    >No seu primeiro acesso você deve seguir os passos abaixo para que sua configuração seja bem sucedida.</div>
    <v-layout row wrap white class="px-5 pt-4 pb-2">
      <v-flex xs4 px-5>
        <v-card elevation="3" class="pt-4 pb-3">
          <h4 class="mb-4 blue-grey--text text--darken-2">1º passo</h4>
          <v-sheet
            style="border-radius:50%; border: 1px dashed #002857;"
            :elevation="0"
            class="mx-auto pt-2 mb-3"
            height="110"
            width="110"
          >
            <v-img :src="cards[0].src" height="80px" contain></v-img>
          </v-sheet>
          <!-- <v-btn flat class="mt-3 mb-3 body-2 primary">{{cards[0].title}}</v-btn> -->
          <ExpenseGroup :button="cards[0].title" />
        </v-card>
      </v-flex>
      <v-flex xs4 px-5>
        <v-card elevation="3" class="pt-4 pb-3">
          <h4 class="mb-4 blue-grey--text text--darken-2">2º passo</h4>
          <v-sheet
            style="border-radius:50%; border: 1px dashed #002857;"
            :elevation="0"
            class="mx-auto pt-2 mb-3"
            height="110"
            width="110"
          >
            <v-img :src="cards[1].src" height="80px" contain></v-img>
          </v-sheet>
          <AccountPlan :button="cards[1].title" />
          <!-- <v-btn flat class="mt-3 mb-3 body-2 primary">{{cards[1].title}}</v-btn> -->
        </v-card>
      </v-flex>
      <v-flex xs4 px-5>
        <v-card elevation="3" class="pt-4 pb-3">
          <h4 class="mb-4 blue-grey--text text--darken-2">3º passo</h4>
          <v-sheet
            style="border-radius:50%; border: 1px dashed #002857;"
            :elevation="0"
            class="mx-auto pt-2 mb-3"
            height="110"
            width="110"
          >
            <v-img :src="cards[2].src" height="80px" contain></v-img>
          </v-sheet>
          <!-- <v-btn flat class="mt-3 mb-3 body-2 primary">{{cards[2].title}}</v-btn> -->
          <FinancialIndex  :button="cards[2].title"/>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import ExpenseGroup from "./expenseGroups/ExpenseGroup";
import AccountPlan from "./accountPlans/AccountPlan";
import FinancialIndex from "./financialIndex/FinancialIndex";
export default {
  components: {
    ExpenseGroup,
    AccountPlan,
    FinancialIndex
  },
  data() {
    return {
      cards: [
        {
          title: "Grupo de despesas",
          src: "./img/icons8-folder-bills-100.png"
        },
        {
          title: "Plano de contas",
          src: "./img/icons8-billing-machine-100.png"
        },
        {
          title: "Índice financeiro",
          src: "./img/icons8-crescimento-económico-100.png"
        }
      ]
    };
  }
};
</script>

<style>
</style>